module.exports = __webpack_public_path__ + "img/certificate-5.59fe7e90.jpg";